import {memo} from 'react';

import styled from 'styled-components';

import {media} from '~/shared/theme/utils';
import {GoogleMapsAPIProvider, TrackerMap} from '~/shared/components/Maps';
import {body18Normal, body15Normal} from '~/shared/theme/typography';
import {getLocalizationService} from '~/shared/services/localisationService';
import {flexCenterHorizontally} from '~/shared/theme/FlexLayout';
import {Coordinate, MapModeEnum} from '~/shared/components/Maps/types';
import {DEFAULT_MAX_ZOOM} from '~/shared/components/Maps/consts';
import {secureOpenWindow} from '~/shared/utils/general';

const MapContainer = styled.div`
  ${flexCenterHorizontally}
  height: 400px;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  ${media.minLargeDesktop`
    height: 450px;
 `}
`;

const UntrackedShippingBadge = styled.div`
  background-color: ${({theme}) => theme.colors.feedbackInfoRegular};
  color: ${({theme}) => theme.colors.primaryText};
  position: absolute;
  top: 16px;
  padding: 4px 8px;
  border-radius: 8px;
  line-height: normal;
  ${body15Normal}
  ${media.minLargeDesktop`
    ${body18Normal}
 `}
`;

const getCoordinate = (latitude: number, longitude: number): Coordinate => ({
  latitude,
  longitude,
});

const onMarkerClick = (latitude: number, longitude: number) => {
  secureOpenWindow(`https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`, '_blank');
};

const OrderSuccessMap = ({
  restaurantLatitude,
  restaurantLongitude,
  userLatitude,
  userLongitude,
  showUntrackedShippingBadge,
  showDummyTracker,
}: {
  restaurantLatitude: number;
  restaurantLongitude: number;
  userLatitude: number;
  userLongitude: number;
  showUntrackedShippingBadge: boolean;
  showDummyTracker: boolean;
}) => {
  const {t} = getLocalizationService();

  const onBusinessMarkerClick = () => {
    if (showDummyTracker) {
      onMarkerClick(restaurantLatitude, restaurantLongitude);
    }
  };

  const onUserMarkerClick = () => {
    if (showDummyTracker) {
      onMarkerClick(userLatitude, userLongitude);
    }
  };

  return (
    <MapContainer className="tracker-container">
      <GoogleMapsAPIProvider>
        <TrackerMap
          mode={MapModeEnum.BEFORE_PICKED_UP}
          businessLocation={getCoordinate(restaurantLatitude, restaurantLongitude)}
          userLocation={getCoordinate(userLatitude, userLongitude)}
          maxZoom={DEFAULT_MAX_ZOOM}
          {...(showDummyTracker ? {onBusinessMarkerClick, onUserMarkerClick} : {})}
        />
        {showUntrackedShippingBadge && <UntrackedShippingBadge>{t('live_delivery_tracking_unavailable')}</UntrackedShippingBadge>}
      </GoogleMapsAPIProvider>
    </MapContainer>
  );
};

export default memo(OrderSuccessMap);
